import intersectionObserverTriggers from '../utils/intersection-observer';

const sectionBlocks = [...document.querySelectorAll('.anim-block')];

const sectionTimeline = [...document.querySelectorAll('.anim-drop')];

const sectionImages = [...document.querySelectorAll('.anim-rtl, .anim-ltr, .anim-pop, .anim-slide, .callout-block--right-slash, .highlights-block__right, .anim-fade--after')];

const graphicalCharts = [...document.querySelectorAll('.anim-graphics')];

const globalMap = [...document.querySelectorAll('.anim-map')];

// animate all blocks on scroll
intersectionObserverTriggers(sectionBlocks, 0.1, "-30px 0px 0px 0px")

// animate all images and icons on scroll
intersectionObserverTriggers(sectionImages, 0.8, "30px 0px 0px 0px");

if(sectionTimeline){
    intersectionObserverTriggers(sectionTimeline, 0.9, "0% 0% -40% 0%");
}

if(graphicalCharts){
    intersectionObserverTriggers(graphicalCharts, 0.5, "0% 0% -30% 0%");
}

if(globalMap){
    intersectionObserverTriggers(globalMap, 0.3, "0% 0% 0% 0%");
}
